/* eslint consistent-return: "off" */

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {ApolloProvider} from '@apollo/client/react';

import apolloClient from '../store/apolloClient';
import store from '../store/store';
import {renderReactNode} from './reactDomCompat';

export default (Element, portal = false, parent = document.getElementById('popup-container')) => {
  if (portal) {
    return ReactDOM.createPortal(Element, parent);
  }
  // Popups render into the persistent #popup-container; no caller reads the DOM
  // in the same tick, so render asynchronously. flushSync here would fire while
  // React is already rendering (popups open from event handlers/effects).
  renderReactNode(
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>{Element}</Provider>
    </ApolloProvider>,
    parent,
    {sync: false},
  );
};
